import "./Companies.html";

import "./Add/AddCompanyComponent";
import "./Details/CompanyDetailsComponent";
import "./Edit/EditCompanyComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import CompaniesComponentController from "./CompaniesComponentController";

export default class CompaniesComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {};
        this.controller = CompaniesComponentController;
        this.templateUrl = "/App/Components/Companies/Companies.html";
    }
}

module("mmManagePortal").component("irCompanies", new CompaniesComponent());
